import{e as r,m as e}from"./chunk-HBP5N4FR.js";var n=r(()=>{e()});export{n as a};
//# sourceMappingURL=chunk-3TSUQSLU.js.map
